import ChatbotBase from "./ChatbotBase";

function Chatbot({ toggleChatbot, openChatbot }) {
    return <ChatbotBase toggleChatbot={toggleChatbot} openChatbot={openChatbot} />;
}

export default Chatbot;
